/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { AutoTestStepResultState } from './AutoTestStepResultState';
const IOTestStepLogBaseParser = /* #__PURE__ */ parsers.object([
    ['state', AutoTestStepResultState],
    ['createdAt', parsers.moment, 'created_at'],
]);
export class IOTestStepLogBase extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return IOTestStepLogBaseParser.decode(input).map(res => new IOTestStepLogBase(res));
    }
    static unsafeDecode(input) {
        return IOTestStepLogBase.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return IOTestStepLogBaseParser.encode(data);
    }
    static schema() {
        return IOTestStepLogBaseParser.schema();
    }
}
